import React from "react";
import styled from "styled-components";
import { FlexColumn, FlexColumnDiv, FlexRow, FlexRowDiv } from "./../common.styles";
import { InlineButtonContainer, LighterText, TinyText } from "../HXDesktopPage.styles";
import { colors } from "healthex-common/colors";
import { HXCheckbox, HXTextField } from "../base.styles";
import { HXButton } from "../HXButton";
import Add from "@mui/icons-material/Add";
import { FileUploadView } from "../FileUploadView";
import CheckCircleOutlined from "@mui/icons-material/Circle";
import DeleteOutlineOutlined from "@mui/icons-material/DeleteOutlineOutlined";
import IconButton from "@mui/material/IconButton";
import { HXAutocomplete } from "../HXAutocomplete";
import Delete from "@mui/icons-material/Delete";
export const addProjectPagesParentPaddingBottom = 40;
export const AddProjectPagesParent = styled(FlexColumnDiv) `
    gap: 16px;
    width: 926px;
    padding: 40px 80px ${addProjectPagesParentPaddingBottom}px 40px;
    ${({ centerAligned }) => centerAligned &&
    `
            margin: auto 0;
        `}
`;
export const AddProjectPageSectionContainer = styled(FlexColumn) `
    padding-top: 0px;
    margin-top: 0px;
    gap: 32px;
`;
export const AddProjectPageSubsectionContainer = styled.div `
    align-self: stretch;
    margin-top: 0px;
`;
export const AddProjectPageSubsectionFieldsContainer = styled(AddProjectPageSectionContainer) `
    margin-top: 16px;
    padding-left: 24px;
    border-left: 3px solid ${colors.navy_8};
`;
export const AddProjectPageTooltipUnorderedList = styled.ul `
    margin-bottom: 0;
`;
export const AddProjectPageViewOnlyItemContainer = styled(FlexColumn) `
    gap: 4px;
`;
export const AddProjectPageViewOnlyItemText = styled(LighterText) `
    white-space: pre-wrap;
`;
export const AddProjectPageViewOnlySpecialCaseItemList = styled.ul `
    margin: 0;
    padding-left: 21px;
    li {
        margin-bottom: 4px;
    }
    li:last-child {
        margin-bottom: 0;
    }
    li::marker {
        color: ${colors.black_lighter};
    }
`;
export const AddProjectPageViewOnlyItemInlineButtonContainer = styled(InlineButtonContainer) `
    text-decoration: underline;
`;
export const AddProjectCheckbox = styled(HXCheckbox) `
    align-self: flex-start;
`;
export const AddProjectAddAdditionalSectionButton = styled(HXButton).attrs({ secondary: true, startIcon: React.createElement(Add) }) `
    align-self: flex-start;
`;
export const AddProjectAddAdditionalQuestionButton = styled(HXButton).attrs({ text: true, startIcon: React.createElement(Add) }) `
    align-self: flex-start;
`;
export const AddJoinCommonInformedConsentStudyOverviewParent = styled(FlexColumnDiv) `
    gap: 32px;
`;
export const AddJoinCommonTitleAndDescription = styled(FlexColumnDiv) `
    gap: 24px;
`;
export const VideoUploadView = styled(FileUploadView) `
    align-self: stretch;
`;
export const TimelineForVisitsContainer = styled(FlexColumn) `
    gap: 16px;
`;
export const TimelineForVisitsItemContainer = styled(FlexRow) `
    gap: 8px;
    position: relative;
`;
export const TimelineForVisitsTimelineContainer = styled(FlexColumnDiv) `
    padding-top: 4px;
    gap: 16px;
`;
export const TimelineForVisitsDot = styled(CheckCircleOutlined) `
    width: 12px;
    height: 12px;
    color: ${(props) => (props.disabled ? colors.sunset_30 : colors.sunset_main)};
`;
export const TimelineForVisitsVerticalDividerContainer = styled(FlexRowDiv) `
    position: absolute;
    top: 32px;
    bottom: 0px;
    width: 12px;
    align-items: center;
`;
export const TimelineForVisitsVerticalDivider = styled.div `
    width: 2px;
    height: 100%;
    margin: 0 auto;
    background-color: ${(props) => (props.disabled ? colors.sunset_30 : colors.sunset_main)};
`;
const TimelineDeleteIcon = styled(DeleteOutlineOutlined) `
    width: 24px;
    height: 24px;
`;
export const TimelineDeleteButton = styled(IconButton).attrs({ children: React.createElement(TimelineDeleteIcon) }) `
    color: ${colors.black_lighter};
`;
export const TimelineForVisitsTextFieldsContainer = styled(FlexColumn) `
    gap: 16px;
    flex: 1 0 0;
`;
export const UpdateFrequency = styled(FlexRowDiv) `
    margin-left: 42px;
    gap: 16px;
    align-items: flex-start;
`;
export const VerticalCenterWrapper = styled(FlexRowDiv) `
    align-items: center;
    height: 40px; // height of sibiling input elements, but won't change if an error is shown, which is desired
`;
export const UpdateEveryTextField = styled(HXTextField) `
    && {
        width: 140px !important;
    }
`;
export const UpdateUnitDropdown = styled(HXAutocomplete) `
    && {
        width: 120px;
    }
`;
export const LogoIconUploadView = styled(FileUploadView) `
    width: 305px;
    height: 305px;
    align-self: flex-start;
`;
export const DeleteSectionButton = styled(HXButton).attrs({
    text: true,
    destructiveAction: true,
    startIcon: React.createElement(Delete),
}) `
    color: ${colors.tulip_main};
`;
export const CharacterLimitDisplay = styled(TinyText) `
    color: ${(props) => (props.error ? colors.tulip_main : colors.black_lighter)};
    margin-left: 14px;
`;
